import { equationBlockRenderer, EquationDecoratorConfig } from './plugins/equation';
import { FITBDecoratorConfig } from './plugins/fill-in-the-blank';
import { imageBlockRenderer, ImageDecoratorConfig } from './plugins/image';
import { LinkDecoratorConfig } from './plugins/link';
import { MergeVarsDecoratorConfig } from './plugins/merge-vars';
import { TooltipDecoratorConfig } from './plugins/tooltip';
import { videoBlockRenderer } from './plugins/video';

export const pluginsConfig = {
  equation: {
    decorator: EquationDecoratorConfig,
    blockRenderer: equationBlockRenderer,
  },
  fillInTheBlank: { decorator: FITBDecoratorConfig },
  image: {
    decorator: ImageDecoratorConfig,
    blockRenderer: imageBlockRenderer,
  },
  link: { decorator: LinkDecoratorConfig },
  tooltip: { decorator: TooltipDecoratorConfig },
  mergeVars: { decorator: MergeVarsDecoratorConfig },
  video: { blockRenderer: videoBlockRenderer },
};
